import { useState } from 'react';
import { IColumnData, IRowData } from '@components/simple-table/types';
import { Type } from '../components/Table/type';
import { ItemTitle as ItemTitle } from '../components/Table/item-title';
import { Action } from '../components/Table/action';
import { MailboxesCell } from '../components/Table/mailboxes';
import { formatDateTime } from '@/lib/utils/date';
import { useTranslation } from 'react-i18next';
import { EllipsisTooltip } from '@components/EllipsisTooltip';

export const useGetColumns = () => {
  const { t } = useTranslation();
  const columnsData: IColumnData[] = [
    {
      width: '200px',
      dataIndex: 'Id',
      title: t('servers.name'),
      hideColumn: false,
      render: (item: IRowData) => <ItemTitle item={item} />
    },
    {
      width: '100px',
      dataIndex: 'Type',
      title: t('roles.roleType'),
      hideColumn: false,
      render: (item: IRowData) => <Type item={item} />
    },
    {
      width: '146px',
      dataIndex: 'owner',
      title: t('owner'),
      hideColumn: false,
      render: (item: IRowData) => <EllipsisTooltip width={140}>{item?.Owner?.Name}</EllipsisTooltip>
    },
    {
      width: '116px',
      dataIndex: 'Counter',
      title: t('participants'),
      hideColumn: false,
      render: (item: IRowData) => item?.Counter
    },
    {
      width: '116px',
      dataIndex: 'filial',
      title: t('unit'),
      hideColumn: false,
      render: (item: IRowData) => (
        <EllipsisTooltip width={200}>{item?.Customer?.Name}</EllipsisTooltip>
      )
    },
    {
      width: '146px',
      dataIndex: 'parentRole',
      title: t('roles.parentalRole'),
      hideColumn: false,
      render: (item: IRowData) => (
        <EllipsisTooltip width={140}>{item?.Parent?.Name}</EllipsisTooltip>
      )
    },
    {
      width: '200px',
      dataIndex: 'PostClientEmails',
      title: t('roles.mailboxes'),
      hideColumn: false,
      render: (item: IRowData) => <MailboxesCell item={item} />
    },
    {
      width: '126px',
      dataIndex: 'dateOfCreation',
      title: t('dateOfCreation'),
      hideColumn: false,
      render: (item: IRowData) => formatDateTime(item?.CreateOfDate)
    },
    {
      width: '80px',
      dataIndex: 'Action',
      title: '',
      hideColumn: false,
      render: (item: IRowData) => <Action item={item} />
    }
  ];

  const [columns, setColumns] = useState<IColumnData[]>(columnsData);

  return { columns, setColumns };
};
